// Vue
import { Vue, Component, Prop, Inject } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import { EventBus } from "@mgs/ci2019-common/src/mixins/event_bus/EventBus";
import { ModuleHelperMixin } from "#/common/ModuleHelperMixin";

// Template
import template from "./template.vue";

@Component({
  mixins: [template],
  components: {},
})
export class ContactPerson extends mixins(EventBus, ModuleHelperMixin) {
  @Prop()
  public person!: object;
}
